import config from '../../config/config';
import { updateEmail, updatePhoneNumber, UpdateStripeId} from '../../interface/profile.interface';

import getRequest from './base/get';
import patchRequest from './base/patch';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Function to fetch list of Accounts
   * @param query
   * @returns
   */
  fetchAccounts: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query, limit: query?.limit || 5 };
    return getRequest(`${config.accountApiUrl}`, { ...parameters });
  },
  /**
   * Function to update email / phone number
   * @param query
   * @returns
   */
  updateEmailPhoneNumber: (data: updateEmail | updatePhoneNumber): Promise<any> => {
    return patchRequest(
      `${config.accountApiUrl}api/facility/v1/users/update-phone-number-email`,
      data,
    );
  },

/**
 * Function to update the Stripe ID for a user.
 * Sends a PATCH request to the API with the provided data.
 * @param {UpdateStripeId} data - The data containing the Stripe ID to update.
 * @returns {Promise<any>} - A promise that resolves with the API response.
 */
updateStripeID: (data: UpdateStripeId): Promise<any> => {
  return patchRequest(
    `${config.accountApiUrl}api/facility/v1/account/update-stripe-id`,
    data,
  );
},


/**
 * Function to get the Stripe ID for a user.
 * Sends a GET request to the API.
 * @returns {Promise<any>} - A promise that resolves with the API response.
 */
getAccount: (data: any): Promise<any> => {
  return getRequest(`${config.accountApiUrl}api/facility/v1/account/get-account`, {...data});
},

};
